<section class="expanded-show">
  <div class="items-content">
    <div class="audio item" *ngIf="audioTracks.length > 0">
      <div class="title-container">
        <div
          class="event-icon"
          inlineSVG="../../assets/icons/audio-icon.svg"
        ></div>
        <span class="item-title-text">Audio</span>
      </div>
      <div class="list-container">
        <div
          class="audio-tracks"
          *ngFor="let track of audioTracks; let i = index"
        >
          <div class="track-container" (click)="toggleSecEvent(show, track.id)">
            <div class="track">
              <span
                class="ear-icon"
                [inlineSVG]="
                  track.properties.enabled
                    ? '../../assets/icons/audio-active.svg'
                    : '../../assets/icons/audio-inactive.svg'
                "
              ></span>
              <span
                [ngClass]="
                  track.properties.enabled
                    ? 'audio-track-text-active'
                    : 'audio-track-text-inactive'
                "
                >{{ track.properties.language }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Uncomment this when P2 is released -->
      <!--            <div class="add-audio-icon" (click)="addAudioPopupHidden=!addAudioPopupHidden" [ngClass]="{'rotate-add-audio-icon': !addAudioPopupHidden}" inlineSVG="../assets/icons/add-sec-event-plus.svg"></div>-->
      <div class="add-audio-popup-container">
        <div
          class="add-audio-popup"
          [ngClass]="{ 'add-audio-popup-hidden': addAudioPopupHidden }"
        >
          <div class="select-items">
            <div class="add-audio-file-text">ADD AUDIO FILE</div>
            <div
              class="select-item-container"
              *ngFor="let track of popupAudioTracks; let i = index"
              (click)="onAddAudioTrackPopupSelect(track)"
            >
              <span class="audio-track-text">{{ track }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="subtitles item" *ngIf="subtitles.length > 0">
      <div class="title-container">
        <div
          class="event-icon subtitles-icon"
          inlineSVG="../../assets/icons/subs-icon-capsul-black.svg"
        ></div>
        <span class="item-title-text">Subtitles</span>
      </div>
      <div class="list-container">
        <div
          class="subtitles-list"
          *ngFor="let sub of subtitles; let i = index"
        >
          <div
            class="language-container"
            (click)="toggleSecEvent(show, sub.id)"
          >
            <div class="language" *ngIf="sub.properties.enabled">
              <span
                class="eye-icon"
                inlineSVG="../../assets/icons/eye-icon.svg"
              ></span>
              <span class="language-text-active">{{
                sub.properties.language
              }}</span>
            </div>
            <div class="language" *ngIf="!sub.properties.enabled">
              <span
                class="eye-icon"
                inlineSVG="../../assets/icons/eye-disabled.svg"
              ></span>
              <span class="language-text-inactive">{{
                sub.properties.language
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="subtitles item" *ngIf="closedCaptions.length > 0">
      <div class="title-container">
        <div
          class="event-icon subtitles-icon"
          inlineSVG="../../assets/icons/closed-captions-icon.svg"
        ></div>
        <span class="item-title-text">Closed Captions</span>
      </div>
      <div class="list-container">
        <div
          class="subtitles-list"
          *ngFor="let cc of closedCaptions; let i = index"
        >
          <div class="language-container" (click)="toggleSecEvent(show, cc.id)">
            <div class="language" *ngIf="cc.properties.enabled">
              <span
                class="eye-icon"
                inlineSVG="../../assets/icons/eye-icon.svg"
              ></span>
              <span class="language-text-active">{{
                cc.properties.language
              }}</span>
            </div>
            <div class="language" *ngIf="!cc.properties.enabled">
              <span
                class="eye-icon"
                inlineSVG="../../assets/icons/eye-disabled.svg"
              ></span>
              <span class="language-text-inactive">{{
                cc.properties.language
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="column-titles-container"
      *ngIf="timedEvents && timedEvents.length > 0"
    >
      <div class="empty-space"></div>
      <div class="name-text">Name</div>
      <div class="text-overrides-text">Text Overrides</div>
      <div class="start-text">Start</div>
      <div class="end-text">End</div>
      <div class="duration-text">Duration</div>
      <div class="offset-text">Offset</div>
      <div class="actions"></div>
    </div>
    <div class="generated-events-container">
      <div class="" *ngFor="let event of timedEvents; let i = index">
        <evrideo-calendar-expandable-autopilot-event
          *ngIf="event.type === secEventType.Autopilot"
          [autopilotData]="event"
          [show]="show"
          [formatDuration]="formatDuration"
          [formatTime]="formatTime"
          [toggleSecEvent]="toggleSecEvent"
        ></evrideo-calendar-expandable-autopilot-event>
        <evrideo-calendar-expandable-graphics-event
          *ngIf="event.type === secEventType.Graphics"
          [graphicsData]="event"
          [show]="show"
          [formatDuration]="formatDuration"
          [formatTime]="formatTime"
          [toggleSecEvent]="toggleSecEvent"
        ></evrideo-calendar-expandable-graphics-event>
        <evrideo-calendar-expandable-signal-event
          *ngIf="[secEventType.Cuetone, secEventType.SCTE].includes(event.type)"
          [show]="show"
          [eventData]="event"
          [formatDuration]="formatDuration"
          [formatTime]="formatTime"
          [toggleSecEvent]="toggleSecEvent"
        ></evrideo-calendar-expandable-signal-event>
        <evrideo-calendar-expandable-floating-media-event
          *ngIf="event.type === secEventType.FloatingMedia"
          [show]="show"
          [floatingMediaData]="event"
          [formatDuration]="formatDuration"
          [formatTime]="formatTime"
          [toggleSecEvent]="toggleSecEvent"
        ></evrideo-calendar-expandable-floating-media-event>
      </div>
    </div>
    <!--        <evrideo-calendar-expandable-new-sec-event class="new-sec-event-component" [showId]="showId"></evrideo-calendar-expandable-new-sec-event>-->
  </div>
</section>
